import styled from "styled-components/macro";

import { RadioGroup as RadioGroupOriginal } from "../../../components";

export const RadioGroup = styled(RadioGroupOriginal)`
  grid-template-columns: 1fr 1fr 1fr;

  .ant-radio-wrapper {
    padding: 16px;
  }

  @media ${({ theme }) => theme.media.tablet} {
    grid-template-columns: 1fr;
  }

  @media ${({ theme }) => theme.media.phone} {
    grid-template-columns: 1fr;
  }
`;

export const FormGroupOfTwoItems = styled.div`
  display: flex;
  gap: 24px;

  .ant-form-item {
    flex-grow: 1;
  }

  @media ${({ theme }) => theme.media.phone} {
    flex-wrap: wrap;
    gap: 0;
  }
`;
